export default "__VITE_ASSET__RzpsQyHq__"